import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import {useEffect, useState} from 'react';
import {ExamModule, UserModule} from '@cp/model';
import TopicSelection from '../../../components/TopicSelection/TopicSelection';

interface ModuleDetailDialogProps {
  open: boolean;
  onClose: () => void;
  module: ExamModule | null;
  userModule: UserModule | null;
  onSave: (topics: string[]) => void;
  loading: boolean;
}

export default function ModuleDetailDialog({
  open,
  onClose,
  module,
  userModule,
  onSave,
  loading,
}: ModuleDetailDialogProps) {
  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);

  useEffect(() => {
    setSelectedTopics(userModule?.topics || []);
  }, [userModule?.topics]);

  const handleTopicSelectionChange = (newSelection: string[]) => {
    setSelectedTopics(newSelection);
  };

  const handleSave = () => {
    onSave(selectedTopics);
  };

  const handleClose = () => {
    // Reset to original selection when closing
    setSelectedTopics(userModule?.topics || []);
    onClose();
  };

  if (!module) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {module.name}
        <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
          Select the topics you want to study
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          <TopicSelection
            moduleTopics={module.topics}
            selectedTopics={selectedTopics}
            onSelectionChange={handleTopicSelectionChange}
            height={400}
            showSelectAll
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{px: 3, pb: 3}}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Saving...' : 'Save Topics'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
